import { IconButton } from "@material-ui/core";
import React, { useState } from "react";
// https://github.com/wojtekmaj/react-pdf/issues/97
import { Document, Page } from "react-pdf/dist/umd/entry.webpack";
import { LOADING_INDICATOR_DELAY_MS } from "../../config";
import { t } from "../../i18n/util";
import { generalStore } from "../../stores/GeneralStore";
import { THEME } from "../../theme/ThemeStore";
import { useMobileMediaQuery } from "../hooks/useMobileMediaQuery";
import { LoadingOverlay } from "./LoadingOverlay";
import { HrBotDialog, SectionHeaderSmall } from "./Primitives";

type Props = {
    url?: string;
    type?: "application/pdf" | "image/jpeg" | "video/mp4";
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const FilePreviewDialog = ({ url, type, isOpen, setIsOpen }: Props) => {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [hover, setHover] = useState(false);

    const isMobile = useMobileMediaQuery();

    const onDocumentLoadSuccess = (doc: any) => {
        setNumPages(doc.numPages);
    };

    return (
        <HrBotDialog open={isOpen} maxWidth={isMobile ? undefined : false} onClose={() => setIsOpen(false)}>
            {type === "application/pdf" && (
                <div
                    style={{ position: "relative", display: "flex", justifyContent: "center" }}
                    onMouseEnter={() => setHover(true)}
                    onMouseLeave={() => setHover(false)}
                >
                    <Document
                        file={url}
                        onLoadSuccess={onDocumentLoadSuccess}
                        loading={<LoadingOverlay delayMs={LOADING_INDICATOR_DELAY_MS} />}
                        error={<></>}
                        onLoadError={(error) => {
                            generalStore.setError(t("error.loadAsset"), error);
                            setIsOpen(false);
                        }}
                    >
                        <Page
                            error={<></>}
                            pageNumber={pageNumber}
                            loading={<LoadingOverlay delayMs={LOADING_INDICATOR_DELAY_MS} />}
                            onLoadError={(error) => {
                                generalStore.setError(t("error.loadAsset"), error);
                                setIsOpen(false);
                            }}
                        />
                    </Document>

                    <div
                        style={{
                            position: "absolute",
                            bottom: 20,
                            display: "flex",
                            opacity: hover ? 1 : 0,
                            transition: "opacity 0.2s linear",
                            alignItems: "center"
                        }}
                    >
                        <IconButton
                            onClick={() => setPageNumber(pageNumber - 1)}
                            disabled={pageNumber === 1}
                            style={{
                                opacity: pageNumber === 1 ? 0.2 : 1
                            }}
                        >
                            <img src={THEME.Images.icChevronLeft} alt="" />{" "}
                        </IconButton>
                        <SectionHeaderSmall label={`${pageNumber} ${t("screen.applicantDocuments.of")} ${numPages}`} />
                        <IconButton
                            onClick={() => setPageNumber(pageNumber + 1)}
                            disabled={pageNumber === numPages}
                            style={{
                                opacity: pageNumber === numPages ? 0.2 : 1
                            }}
                        >
                            <img src={THEME.Images.icChevronRight} alt="" />{" "}
                        </IconButton>
                    </div>
                </div>
            )}
            {type === "image/jpeg" && <img src={url} alt="" style={{ margin: 5 }} />}
            {type === "video/mp4" && (
                <video height={isMobile ? "240" : "480"} controls>
                    <source src={url} type="video/mp4" />
                </video>
            )}
        </HrBotDialog>
    );
};
